//
// extended-definition-layout
//
// Build a client-only layout for an extended definition:
//   vertical
//     ├── definition (base)
//     ├── section-header + class … (extra classes)
//     └── section-header + horizontal left/right fields (extra fields)

import { LAYOUTCOMPONENTTYPECONFIG } from './LAYOUTCOMPONENTTYPECONFIG'

export function synthesizeLayoutForExtendedDefinition(definition, rootstore) {
    const base = definition.original
        ? rootstore.data.definitions.get(definition.original)
        : null
    const base_classes = base ? base.classes : []
    const base_fields = base ? base.fields : []

    const extra_classes = definition.classes.filter(
        class_gid => !base_classes.includes(class_gid)
    )
    const extra_fields = definition.fields.filter(
        field_gid => !base_fields.includes(field_gid)
    )

    const root_gid = `${definition.gid}:root`
    const base_gid = `${definition.gid}:base`
    const fields_header_gid = `${definition.gid}:fields-header`
    const fields_gid = `${definition.gid}:fields`
    const fields_left_gid = `${definition.gid}:fields-left`
    const fields_right_gid = `${definition.gid}:fields-right`

    const components = {}
    const root_content = [base_gid]

    components[base_gid] = {
        gid: base_gid,
        type: 'definition',
        definition: definition.original,
        editable: true,
    }

    extra_classes.forEach(class_gid => {
        if (!rootstore.data.classes.get(class_gid)) return

        const header_gid = `${definition.gid}:class-header:${class_gid}`
        const component_gid = `${definition.gid}:class:${class_gid}`
        root_content.push(header_gid, component_gid)
        components[header_gid] = {
            gid: header_gid,
            type: 'section-header',
            class: class_gid,
            tag: rootstore.app.text('extension class'),
        }
        components[component_gid] = {
            gid: component_gid,
            type: 'class',
            class: class_gid,
            placeholder: '',
            editable: true,
            width: 250,
            columns: 3,
        }
    })

    if (extra_fields.length) {
        const left_content = []
        const right_content = []

        extra_fields.forEach(field_gid => {
            const field = rootstore.data.fields.get(field_gid)
            if (!field) return

            const fieldtypeconfig =
                LAYOUTCOMPONENTTYPECONFIG['field']['typeconfig'][field.type]
            const fieldtypestyle =
                fieldtypeconfig && fieldtypeconfig['style']
                    ? fieldtypeconfig['style']['default']
                    : undefined
            const fieldtypelayout =
                fieldtypeconfig && fieldtypeconfig['layout']
                    ? fieldtypeconfig['layout']
                    : undefined

            const component_gid = `${definition.gid}:field:${field_gid}`
            components[component_gid] = {
                gid: component_gid,
                type: 'field',
                field: field_gid,
                placeholder: '',
                editable: true,
                style: fieldtypestyle,
                width: 250,
                columns: 3,
            }
            if (fieldtypelayout === 'right') {
                right_content.push(component_gid)
            } else {
                left_content.push(component_gid)
            }
        })

        if (left_content.length || right_content.length) {
            components[fields_header_gid] = {
                gid: fields_header_gid,
                type: 'section-header',
                title: rootstore.app.text('Fields'),
                tag: rootstore.app.text('extension'),
            }
            components[fields_left_gid] = {
                gid: fields_left_gid,
                type: 'vertical',
                size: 'grow',
                content: left_content,
            }
            components[fields_right_gid] = {
                gid: fields_right_gid,
                type: 'vertical',
                size: 250,
                content: right_content,
            }
            components[fields_gid] = {
                gid: fields_gid,
                type: 'horizontal',
                content: [fields_left_gid, fields_right_gid],
            }
            root_content.push(fields_header_gid, fields_gid)
        }
    }

    components[root_gid] = {
        gid: root_gid,
        type: 'vertical',
        content: root_content,
    }

    return {
        gid: definition.gid,
        original: null,
        name: definition.name || '',
        root: root_gid,
        components,
        gid_map: {},
        is_new: false,
        is_working_copy: false,
    }
}
